<div class="auth-wrapper auth-v2">
    <div class="auth-inner row m-0">
        <!-- Brand logo-->
        <a class="brand-logo" href="javascript:void(0);"><img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" height="28"/></a>
        <!-- /Brand logo-->
        <!-- Left Text-->
        <div class="d-none d-lg-flex col-lg-8 align-items-center p-5">
            <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
                <img src="../../../../assets/images/pages/login-illustration.svg" *ngIf="coreConfig.layout.skin !== 'dark'" alt="">
                <img src="../../../../assets/images/pages/login-illustration-dark.svg" *ngIf="coreConfig.layout.skin === 'dark'" alt="">
            </div>
        </div>
        <!-- /Left Text-->
        <!-- Reset password-->
        <div class="d-flex col-lg-4 align-items-center auth-bg px-2 p-lg-5">
            <div class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto">
                <h2 class="card-title font-weight-bold mb-1">{{isCreatePasswordPage ? ("AUTH.CREATE_PASSWORD" | translate) : ("CHANGE_PASSWORD" | translate)}} 🔒</h2>
                <p class="card-text mb-2">{{isCreatePasswordPage ? ("AUTH.CREATE_PASSWORD_DISCLAIMER" | translate) : ("AUTH.CHANGE_PASSWORD_DISCLAIMER" | translate)}}</p>
                <form class="auth-reset-password-form mt-2" [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
                    <div class="form-group">
                        <div class="d-flex justify-content-between">
                            <label for="reset-password-new">{{'PASSWORD'|translate}}</label>
                        </div>
                        <div class="input-group input-group-merge form-password-toggle">
                            <input [type]="passwordTextType ? 'text' : 'password'" formControlName="newPassword"
                                   class="form-control form-control-merge" id="reset-password-new"
                                   placeholder="············" aria-describedby="reset-password-new" tabindex="1" autofocus
                                   [ngClass]="{ 'is-invalid error': submitted && f.newPassword.errors }"/>
                            <div class="input-group-append">
                                    <span class="input-group-text cursor-pointer">
                                             <i class="feather font-small-4"
                                                [ngClass]="{'icon-eye-off': passwordTextType,'icon-eye': !passwordTextType}"
                                                (click)="togglePasswordTextType()">
                                             </i>
                                    </span>
                            </div>
                        </div>
                        <div *ngIf="submitted && f.newPassword.errors" class="invalid-feedback"
                             [ngClass]="{ 'd-block': submitted && f.newPassword.errors }">
                            <div *ngIf="f.newPassword.errors.required">{{"AUTH.PASSWORD_IS_REQUIRED" | translate}}</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="d-flex justify-content-between">
                            <label for="reset-password-confirm">{{"CONFIRM_PASSWORD" | translate}}</label>
                        </div>
                        <div class="input-group input-group-merge form-password-toggle">
                            <input [type]="confPasswordTextType ? 'text' : 'password'" formControlName="confirmPassword"
                                   class="form-control form-control-merge" id="reset-password-confirm"
                                   placeholder="············" aria-describedby="reset-password-confirm" tabindex="2"
                                   [ngClass]="{ 'is-invalid error': submitted && f.confirmPassword.errors }"/>
                            <div class="input-group-append">
                                <span class="input-group-text cursor-pointer">
                                    <i class="feather font-small-4" [ngClass]="{'icon-eye-off': confPasswordTextType,'icon-eye': !confPasswordTextType}"
                                       (click)="toggleConfPasswordTextType()">
                                    </i>
                                </span>
                            </div>
                        </div>
                        <div *ngIf="submitted && f.confirmPassword.errors" class="invalid-feedback"
                             [ngClass]="{ 'd-block': submitted && f.confirmPassword.errors }">
                            <div *ngIf="f.confirmPassword.errors.required">{{"AUTH.PASSWORD_IS_REQUIRED" | translate}}</div>
                        </div>
                    </div>
                    <button class="btn btn-primary btn-block" tabindex="3" rippleEffect>{{isCreatePasswordPage ? ("AUTH.CREATE_PASSWORD" | translate) : ("CHANGE_PASSWORD" | translate)}}</button>
                </form>
                <p class="text-center mt-2" *ngIf="!isCreatePasswordPage">
                    <a routerLink="/auth/login"><i data-feather="chevron-left" class="mb-25"></i> {{"AUTH.BACK_TO_LOGIN" | translate}}</a>
                </p>
            </div>
        </div>
        <!-- /Reset password-->
    </div>
</div>
